<script setup lang="ts">
import { onMounted, ref } from "vue";
import BaseButton from "@/components/base/BaseButton.vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import { useI18n } from "vue-i18n";

const router = useRouter();

const store = useStore();
const { t } = useI18n();

const sections = ref([
  {
    title: t("support.sections.faq"),
    step: "faq",
  },
  {
    title: t("support.sections.feedback"),
    step: "feedback",
  },
]);

const setSettingsStep = (sectionsStep: string) => {
  if (sectionsStep === "faq") {
    router.push("/faq");
  } else if (sectionsStep === "feedback") {
    router.push("/feedback");
  }
};

const clearData = async () => {
  store.dispatch("auth/logout");
};

onMounted(() => {
  store.dispatch("updateAsideVisibility", false);
});
</script>

<template>
  <div class="settings">
    <div class="settings__main">
      <h1 class="settings__title h1 color-text-primary">
        {{ t("support.title") }}
      </h1>
      <div class="settings__sections">
        <div
          v-for="(item, index) in sections"
          :key="index"
          class="settings__section h4 color-text-primary"
          @click="setSettingsStep(item.step)"
        >
          {{ item.title }}
          <BaseFigureForIcon
            icon="more"
            color="secondary"
            size="small"
            is-button
          />
        </div>
      </div>
      <BaseButton
        @click="clearData()"
        :title="t('support.logout')"
        size="large"
        color="transparent-primary"
        class="logout-btn"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/style/main";

.settings {
  display: flex;
  width: 100%;
  max-width: 720px;
  margin: 45px 0;

  @media (max-width: 960px) {
    margin: 0;
    width: 100%;
    height: 100%;
  }

  &__main {
    width: 100%;
  }

  &__title {
    display: flex;
    margin-bottom: 32px;

    @media (max-width: 960px) {
      display: flex;
      align-items: flex-start;
      margin: 12px 0 31px 24px;
    }
  }

  &__sections {
    display: flex;
    flex-direction: column;
    gap: 13px;
    width: 100%;
    margin-bottom: 22px;

    @media (max-width: 960px) {
      padding: 0 24px;
      gap: 11px;
      margin-bottom: 0;
    }
  }

  &__section {
    display: flex;
    padding: 38px 38px 38px 24px;
    background-color: var(--color-white);
    border-radius: 32px;
    justify-content: space-between;
    cursor: pointer;

    @media (max-width: 960px) {
      padding: 24px 23px 24px 20px;
      border-radius: 24px;
    }
  }

  &__img {
    width: 24px;
    height: 24px;
    background-color: var(--color-secondary);
    padding: 4px;
    transform: rotate(-90deg);
    border-radius: 24px;
  }

  &__version {
    color: var(--color-text-input);
    margin-top: 22px;
    @media (max-width: 960px) {
      position: absolute;
      bottom: 125px;
      display: flex;
      left: 24px;
    }
  }
}

.logout-btn {
  display: none;
  @media (max-width: 960px) {
    position: absolute;
    bottom: 150px;
    display: flex;
    left: -16px;
  }
}
</style>
